/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.microcredentials'},
});

const MicrocredentialsItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/microcredentials"
    title={messages.title}
  />
);

export default MicrocredentialsItem;
